import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { PersistedStore } from './app/store';

const root = document.getElementById('root');
if (root) {
    const renderer = createRoot(root);
    renderer.render(<React.StrictMode>{PersistedStore}</React.StrictMode>);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
